<template>
  <div
    class="edit-container"
    ref="editCom"
    @click.stop
  >
    <el-dialog 
      :model-value="true"
      :title="title" 
      align-center 
      width="62.5rem"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeFun"
      :show-close="showClose"
    >
      <el-scrollbar
        :max-height="600"
      >
        <el-form 
          :model="target"
          label-position="top"
          :rules="rules"
          ref="formRef"
        >
          <el-space fill
            v-for="(input, index) in inputList"
            :key="index"
            style="width: 100%;"
          >
            <el-form-item
              :label="input.name"
              :prop="input.prop"
              :class="{
                'form-item-map-scope-sign': input.type == 'mapScopeSign',
                'form-item-canvas-img-rec': input.type == 'canvasImgRec',
              }"
            >
              <el-select
                v-if="input.type == 'select'"
                v-model="target[input.prop]"
                :filterable="input.select.filterable"
                :multiple="input.select.multiple"
                :allow-create="input.select.allowcreate"
                :reserve-keyword="input.select.reserveKeyword"
                :disabled="input.select.disabled"
                :loading="input.select.loading"
                style="width: 100%;"
                @change="input.select.changeFun?input.select.changeFun(target, input, $event):()=>{}"
                clearable
              >
                <template #prefix>
                  <el-icon v-if="input.select.loading" class="is-loading"><Loading /></el-icon>
                  <el-button size="small" v-if="input.select.multiple"
                    @click.stop="selectAllClick(target, input)"
                  >全选</el-button>
                </template>
                <el-option
                  v-for="(selet, selectIndex) in target[input.select.list]"
                  :key="selectIndex"
                  :label="selet[input.select.label]"
                  :value="
                    input.select.value == 'this'
                      ?selectThisChange(selet)
                      :selet[input.select.value]
                  "
                >
                </el-option>
              </el-select>
              <el-checkbox-group
                v-else-if="input.type == 'checkboxgroup'"
                v-model="target[input.prop]"
                style="width: 100%;"
              >
                <template v-if="input.checkboxgroup.checkboxButton">
                  <el-checkbox-button
                    v-for="(item, idx) in target[input.checkboxgroup.list]"
                    :key="idx"
                    :value="item[input.checkboxgroup.value]"
                  >
                    {{ item[input.checkboxgroup.label] }}
                  </el-checkbox-button>
                </template>
                <template v-else>
                  <el-checkbox
                    v-for="(item, idx) in target[input.checkboxgroup.list]"
                    :key="idx"
                    :value="item[input.checkboxgroup.value]"
                  >
                    {{ item[input.checkboxgroup.label] }}
                  </el-checkbox>
                </template>
              </el-checkbox-group>
              <el-tree
                v-else-if="input.type == 'tree'"
                style="width: 100%;"
                default-expand-all
                :data="target[input.tree.list]"
                show-checkbox
                :node-key="input.tree.key"
                :props="input.tree"
                :default-checked-keys="target[input.prop]"
                :valKey="input.prop"
                @check="(node, keyInfo)=>{ checkFun(node, keyInfo, input) }"
                ref="tree"
              >
              </el-tree>
              <el-date-picker
                v-else-if="input.type == 'date'"
                style="width: 100%;"
                v-model="target[input.prop]"
                type="date"
                placeholder="请选择日期"
                :disabled-date="input.date.disabledFun?input.date.disabledFun:()=>{}"
              />
              <el-date-picker
                v-else-if="input.type == 'datetime'"
                style="width: 100%;"
                v-model="target[input.prop]"
                type="datetime"
                placeholder="请选择日期和时间"
                :disabled-date="input.date.disabledFun?input.date.disabledFun:()=>{}"
              />
              <el-time-picker
                v-else-if="input.type == 'time'"
                v-model="target[input.prop]"
                placeholder="选择时间"
              />
              <el-input-number
                v-else-if="input.type == 'number'"
                style="width: 100%;"
                v-model="target[input.prop]"
                :min="input.number && input.number.min" :max="input.number && input.number.max"
                @change="input['changeFun']?input['changeFun'](target, input, $event):()=>{}"
              />
              <el-upload
                class="avatar-uploader"
                v-else-if="input.type == 'upload'"
                :show-file-list="false"
                :auto-upload="false"
                action=""
                :accept="input.upload.type||''"
                v-loading="input['loading']"
                :on-change="
                  (file, fileList)=>{
                    if(input.upload.fun){
                      input.upload.fun(file, fileList, target, input);
                    }
                  }
                "
              >
                <img v-if="target[input.prop]"
                  :src="input.upload.prefixUrl?input.upload.prefixUrl+target[input.prop]:target[input.prop]"
                  class="avatar" 
                />
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
              <el-row
                v-else-if="input.type == 'verifycode'"
                :style="{width: '100%'}"
              >
                <el-col :span="16">
                  <el-input v-model="target[input.prop]" />
                </el-col>
                <el-col :span="6" :offset="2">
                  <VerifyCode 
                    :style="{
                      height: '1.875rem',
                    }"
                    @randomNumberChange="input.randomNumberChange"
                  />
                </el-col>
              </el-row>

              <el-input 
                v-else-if="input.type == 'textarea'"
                v-model="target[input.prop]"
                type="textarea"
                :autosize="{ minRows: 4 }"
              />
              <el-color-picker
                v-else-if="input.type == 'color'"
                v-model="target[input.prop]"
                @change="input['changeFun']?input['changeFun'](target, input, $event):()=>{}"
              ></el-color-picker>
                
              <LeafletConstructor 
                v-else-if="input.type == 'mapScopeSign'"
                @mapInit="(map)=>{ scopeSignMapInit(map, input, target) }"
                :isAddBaseLayer="true"
              />
              <LeafletConstructor
                v-else-if="input.type == 'canvasImgRec'"
                @mapInit="(map)=>{ canvasImgRecInit(map, input, target) }"
                :isAddBaseLayer="true"
              />
              <LeafletConstructor
                v-else-if="input.type == 'mapPreview'"
                @mapInit="(map)=>{ input.onMapInit && input.onMapInit(map, target) }"
                :isAddBaseLayer="true"
                :isDragging="input.isDragging ?? false"
                :scrollWheelZoom="input.scrollWheelZoom ?? false"
                :zoomShow="input.zoomShow ?? false"
                :isShowInfoControl="input.isShowInfoControl ?? false"
                :height="input.height ?? '25rem'"
              />
              <div v-else-if="input.type == 'tags'"
                class="edit-context-tags"
              >
                <el-scrollbar>
                  <el-tag
                    :key="tagIndex"
                    v-for="(tag, tagIndex) in (target[input.prop] || [])"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag, target, input)">
                    {{tag}}
                  </el-tag>
                  <el-input
                    class="input-new-tag"
                    v-if="tagInputShow[input.prop]"
                    v-model="tagInputValue[input.prop]"
                    size="small"
                    @keyup.enter="handleInputConfirm(target, input)"
                    @blur="handleInputConfirm(target, input)"
                    :autofocus="true"
                  >
                  </el-input>
                  <el-button v-else class="button-new-tag" size="small" @click="showInput(input)">+ 新标签</el-button>
                </el-scrollbar>
              </div>
              <div
                v-else-if="input.type == 'KeyValList'"
                class="key-val-list-edit"
              >
                <el-table
                  :data="target[input.prop]"
                  height="18.75rem"
                >
                  <el-table-column prop="type" label="类型">
                    <template #default="scope">
                      <el-select
                        v-model="scope['row'][input['KeyValList']['key']]"
                        size="small"
                        allow-create
                        filterable
                      >
                        <el-option
                          v-for="(echo, echoIndex) in target[input['KeyValList']['list']] || []"
                          :key="echoIndex"
                          :value="
                            input['KeyValList']['typeList']['value'] == 'this'
                            ?selectThisChange(echo)
                            :echo[input['KeyValList']['typeList']['value']]
                          "
                          :label="echo[input['KeyValList']['typeList']['label']]"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="value" label="值">
                    <template #default="scope">
                      <el-input
                        type="textarea"
                        v-model="scope['row'][input['KeyValList']['value']]"
                        :autosize="{ minRows: 4 }"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template #header>
                      <el-button :icon="Delete" type="danger"
                        @click.stop="echodeleteAllFn(scope, target, input)"
                        size="small"
                      ></el-button>
                    </template>
                    <template #default="scope">
                      <el-button :icon="Delete" type="danger"
                        @click.stop="echodeleteFn(scope, target, input)"
                        size="small"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button :icon="Plus"
                  size="small"
                  type="primary"
                  style="margin-top: 0.3125rem"
                  @click="echoAddFn(target, input.prop)"
                ></el-button>
                <slot name="KeyValSelect"
                  :item="target"
                  :input="input"
                ></slot>
              </div>
              <el-input 
                v-else
                v-model="target[input.prop]"
              />
              <p
                v-if="input.message"
                :style="{
                  'font-size': '0.75rem',
                  color: 'var(--el-color-danger)',
                  height: '1.25rem',
                  'line-height': '1.25rem',
                }"
              >
                *{{ input.message.text }}
              </p>
            </el-form-item>
          </el-space>
          <slot></slot>
        </el-form>
      </el-scrollbar>
      <template #footer>
        <div class="dialog-footer">
          {{ message }}
          <br />
          <el-button
            v-for="(button, buttonIndex) in buttonList"
            :key="buttonIndex"
            :type="button.type"
            size="small"
            @click="fun(button, target)"
            :loading="target && target[`${button.name}load`]"
          >{{ button.name }}</el-button>
          <!-- <ButtonList 
            :list="buttonList" :target="target"
          /> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue';
import store from '@/store';

import {
  createApp,
} from 'vue';
import ElementPlus from 'element-plus';
import {
  Plus, Delete, Loading,
} from '@element-plus/icons-vue';

import ButtonList from '@/components/ButtonList';
import VerifyCode from '@/components/VerifyCode';
import LeafletConstructor from '@/components/LeafletConstructor';
import LatLngInput from '@/components/EditCom/component/LatLngInput';

import { ElMessage } from 'element-plus'
import { svgControlCreate, colorControlCreate } from '@/utils/js/leafletUtils';

// props
const props = defineProps({
  target: { type: Object, default: ()=>{ return {}; } },
  title: { type: String, default: ()=>{ return ''; } },
  buttonList: { type: Array, default: ()=>{ return []; }, },
  inputList: { type: Array, default: ()=>{ return []; }, },
  rules: { type: Object, default: ()=>{ return []; }, },
  message: { type: String, default: ()=>{ return ''; } },
  showClose: { type: Boolean, default: ()=>{ return true }, },
});
// emit
const emit = defineEmits([
  'closeFun',
]);

const closeFun = ()=>{
  emit('closeFun');
}

const echoAddFn = (target, prop)=>{
  if(!target[prop]){
    target[prop] = [];
  }
  target[prop].push({});
},
echodeleteFn = (scope, target, input)=>{
  const index = scope['$index'];
  // console.log(target, index);
  target[input.prop].splice(index, 1);
},
echodeleteAllFn = (scope, target, input)=>{
  target[input.prop].splice(0)
}
const selectThisChange = (val)=>{
  if(val instanceof Object){
    return JSON.parse(val);
  }
  return val
}

const tagInputValue = reactive({}),
      tagInputShow = reactive({}),
handleClose = (tag, target, prop)=>{
  if(target[prop.prop].indexOf(tag) == -1)return;
  target[prop.prop].splice(target[prop.prop].indexOf(tag), 1);
},
handleInputConfirm = (target, prop)=>{
  let inputValue = tagInputValue[prop.prop];
  // this.$set(this.tagInputValue, prop.prop, true);
  if (inputValue) {
    if(!target[prop.prop]){
      target[prop.prop] = [];
    }
    target[prop.prop].push(inputValue);
  }
  tagInputShow[prop.prop] = false;
  tagInputValue[prop.prop] = '';
},
showInput = (prop)=>{
  nextTick(()=>{
    tagInputShow[prop.prop] = true;
  })
}

const selectAllClick = (target, input)=>{
  // console.log(target, input);
  const selectList = target[input.select.list];
  // console.log(selectList);
  if((target[input.prop] || []).length == selectList.length){
    target[input.prop] = [];
  }else{
    target[input.prop] = selectList.map(item=>{
      return input.select.value == 'this'?selectThisChange(item):item[input.select.value];
    })
  }
}

const polygonStyle = store.getters['leafletRec/polygonStyle'],
      recStyle = store.getters['leafletRec/getConfig'];

const canvasImgRecInit = (map, input, target)=>{
  // console.log(map, input, target);
  const layerGroup = L.featureGroup().addTo(map),
        layerGroupClear = ()=>{
          layerGroup.clearLayers();
        }
  var drawControl = new L.Control.Draw({
    position: 'topright',
    draw: {
      polyline: false, // 禁用绘制折线
      rectangle: true, // 禁用绘制矩形
      circle: false, // 禁用绘制圆形
      marker: false, // 禁用标记点
      circlemarker: false, // 禁用圆形标记点
      polygon: false, // 启用绘制多边形
    },
    edit: {
      featureGroup: layerGroup,
      remove: true, // 启用清除功能
      edit: true,
    }
  }).addTo(map);
  
  const latlngChangeinputVal = (latlng)=>{
    return `${ latlng['lat'] },${latlng['lng']}`;
  }
  const inputValChange = (bounds, inputMap)=>{
    for(const key in inputMap){
      const val = inputMap[key];
      const latlng = bounds[`get${key}`]();
      const marker = val['marker'], vm = val['vm'];
      marker && marker.setLatLng(latlng);
      vm && vm.changeLatLngVal && vm.changeLatLngVal(latlngChangeinputVal(latlng));
      // console.log(key, val, latlng);
    }
  }
  const latlngInputInit = (bounds, layer)=>{
    // console.log(bounds);
    const iconW = 200, iconH = 'auto';
    const latlngList = [
      { latlng: bounds.getNorthWest(), mapProp: 'NorthWest', reverseProp: 'SouthEast', offset: [ iconW / 2, 36 ], }, // 左上/西北
      { latlng: bounds.getNorthEast(), mapProp: 'NorthEast', reverseProp: 'SouthWest', offset: [ iconW / 2, 36 ] }, // 右上/东北
      { latlng: bounds.getSouthWest(), mapProp: 'SouthWest', reverseProp: 'NorthEast', offset: [ iconW / 2, -6 ] }, // 左下/西南
      { latlng: bounds.getSouthEast(), mapProp: 'SouthEast', reverseProp: 'NorthWest', offset: [ iconW / 2, -6 ] }, // 右下/东南
    ];
    const inputMap = {
      
    };
    latlngList.forEach((item)=>{
      const latlngVal = latlngChangeinputVal(item.latlng);
      const app = createApp(LatLngInput, {
        change: (val)=>{
          // console.log(val, item, inputMap, bounds);
          const recBounds = layer.getBounds(),
                reverseLatLng = recBounds[`get${item.reverseProp}`]();
          layer.setBounds([ val, reverseLatLng ]);
          inputValChange(layer.getBounds(), inputMap);
        },
        defaultVal: latlngVal,
      });
      const div = document.createElement("div");
      app.use(ElementPlus);
      const vm = app.mount(div);
      
      const customIcon = L.divIcon({
        html: div,
        iconSize: [iconW, iconH], // 图标大小
        iconAnchor: item.offset,
      });

      inputMap[item.mapProp] = {
        marker: L.marker(
          item.latlng, {
            icon: customIcon,
          }
        ),
        vm,
      }
    });
    return inputMap;
  }
  let latlngInputMap, latlngInputMapClose = ()=>{ latlngInputMap = undefined; };
  map.on(L.Draw.Event.CREATED, function (e) {
    // console.log(e);
    const layer = e.layer;
    layerGroupClear();
    layerGroup.addLayer(layer);
    layer.setStyle(recStyle);
    layer.on({
      remove: event=>{
        layerGroupClear();
        latlngInputMapClose();
      }
    })
    target[input.prop] = layer;
    const bounds = layer.getBounds();
    latlngInputMap = bounds.isValid() && latlngInputInit(bounds, layer);
    for(const key in latlngInputMap){
      const val = latlngInputMap[key];
      layerGroup.addLayer(val['marker']);
    }
  });
  map.on(L.Draw.Event.EDITRESIZE, function (e) {
    const layer = e.layer, bounds = layer.getBounds();
    inputValChange(bounds, latlngInputMap);
  })
  map.on(L.Draw.Event.EDITMOVE, function (e) {
    const layer = e.layer, bounds = layer.getBounds();
    inputValChange(bounds, latlngInputMap);
  })
}

const scopeSignMapInit = (map, input, target)=>{
  // console.log(map, input, target);
  const layerGroup = L.featureGroup().addTo(map),
        uploadLayerGroup = L.featureGroup().addTo(map);
  let uploadGeojson;
  const layerStyle = {
    ...polygonStyle,
  };

  if(target[input.prop]){
    const geojson = L.geoJSON(JSON.parse(target[input.prop]), {
      ...layerStyle,
      // onEachFeature: (feature, layer)=>{
      //   layer.setStyle({
      //     color: feature['properties']['fill'] || layerStyle.color,
      //   })
      // } 
    }).addTo(layerGroup);
    map.fitBounds(geojson.getBounds());
  }
  const uploadLayerGroupClear = ()=>{
    const layer = layerGroup.getLayers().at(0);
    uploadLayerGroup.clearLayers();
    if(layer){
      if(uploadGeojson && uploadGeojson.hasLayer(layer)){
        target[input.prop] = '';
      }
    }
  }
  const layerGroupClear = ()=>{
    const layer = layerGroup.getLayers().at(0);
    layerGroup.clearLayers();
    if(layer){
      if(uploadGeojson && uploadGeojson.hasLayer(layer)){
        layer.setStyle({ color: layerStyle.color });
        layer.addTo(uploadLayerGroup);
      }
    }
  }
  var drawControl = new L.Control.Draw({
    position: 'topright',
    draw: {
      polyline: false, // 禁用绘制折线
      rectangle: false, // 禁用绘制矩形
      circle: false, // 禁用绘制圆形
      marker: false, // 禁用标记点
      circlemarker: false, // 禁用圆形标记点
      polygon: true, // 启用绘制多边形
    },
    edit: {
      featureGroup: layerGroup,
      remove: true // 启用清除功能
    }
  }).addTo(map);
  map.on(L.Draw.Event.CREATED, function (e) {
    if(input['polygon'] && input['polygon']['oneFlag']){
      layerGroupClear();
    }
    var layer = e.layer;
    layer.setStyle(layerStyle);
    layerGroup.addLayer(layer);
    target[input.prop] = JSON.stringify(layerGroup.toGeoJSON());
  });
  map.on(L.Draw.Event.EDITED, function (e) {
    target[input.prop] = JSON.stringify(layerGroup.toGeoJSON());
  });
  map.on(L.Draw.Event.DELETESTOP, function (e) {
    if(layerGroup.getLayers().length > 0){
      target[input.prop] = JSON.stringify(layerGroup.toGeoJSON());
    }else{
      target[input.prop] = '';
    }
  });

  // 监听清除事件
  map.on(L.Draw.Event.DELETED, function (e) {
    layerGroupClear();
  });

  // 文件上传control
  const fileButton = document.createElement('input');
  fileButton.type = 'file';
  fileButton.accept = '.json,.geojson';
  const control = svgControlCreate({
    title: '文件上传',
    svgName: 'file-upload',
  }, 'click', ()=>{
    fileButton.click();
  })
  try {
    fileButton.onchange = (e)=>{
      document.activeElement.style['cursor'] = 'wait';
      const fileInput = e.target,
            file = Array.from(fileInput['files']).at(0);
      if(!file){
        document.activeElement.style['cursor'] = 'default';
        return;
      };
      uploadLayerGroupClear();
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e)=>{
        const that = e.target,
        json = JSON.parse(that['result']);
        uploadGeojson = L.geoJSON(json, {
          ...layerStyle,
          pointToLayer: (geoJsonPoint, latlng)=>{
            return undefined
          },
          onEachFeature: (feature, layer)=>{
            // layer.setStyle({
            //   color: feature['properties']['fill'] || layerStyle.color,
            // })
            layer.on({
              click: event=>{
                if(layerGroup.hasLayer(layer)){
                  layerGroup.removeLayer(layer);
                  layer.setStyle({
                    color: feature['properties']['fill'] || layerStyle.color,
                  })
                  uploadLayerGroup.addLayer(layer);
                  target[input.prop] = '';
                }else{
                  layerGroupClear();
                  // oldLayer = layerGroup.getLayers().at(0);
                  uploadLayerGroup.removeLayer(layer);
                  layer.setStyle({
                    color: 'rgb(255, 54, 36)',
                  })
                  layerGroup.addLayer(layer);
                  target[input.prop] = JSON.stringify(layerGroup.toGeoJSON());
                }
              }
            })
          }
        }).addTo(uploadLayerGroup);
        map.fitBounds(uploadGeojson.getBounds());
        document.activeElement.style['cursor'] = 'default';
      }
    }
  } catch (error) {
    document.activeElement.style['cursor'] = 'default';
  }
  control.addTo(map);

  // 颜色选择器control
  const colorCrontrol = colorControlCreate(undefined, (event)=>{
    const layer = layerGroup.getLayers().at(0);
    if(layer){
      const color = event.target['value'];
      layer.setStyle({
        color,
      });
      const geojson = layerGroup.toGeoJSON();
      const feature = geojson['features'] && geojson['features'].at(0);
      if(feature){
        feature['properties']['fill'] = color;
      }
      target[input.prop] = JSON.stringify(geojson);
    }
  })
  colorCrontrol.addTo(map);
}
const 
  formRef = ref(),
  fun = (button, target)=>{
    if(button.fun){
      if(target){
        target[`${button.name}load`] = true;
      }
      button.fun(formRef, target, button, ()=>{
        target[`${button.name}load`] = false;
      });
    }
  },
  checkFun = (node, keyInfo, input)=>{
    props.target[input.prop] = keyInfo.checkedKeys;
    props.target[input.prop+`_halfKey`] = keyInfo.halfCheckedKeys;
  },
  tree = ref([]),
  treeValInit = ()=>{
    for(const t of tree.value){
      const valKey = t.$.attrs.valKey;
      props.target[valKey] = t.getCheckedKeys();
      props.target[valKey+`_halfKey`] = t.getHalfCheckedKeys();
    }
  }

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  nextTick(()=>{
    treeValInit();
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.key-val-list-edit{
  width: 100%;
}
.edit-context-tags{
  width: 100%;
  :deep(.el-scrollbar){
    .el-scrollbar__view{
      max-height: 120px;
      .el-tag{
        margin-right: 10px;
      }
      .input-new-tag{
        width: 160px;
      }
    }
  }
}
:deep(.form-item-map-scope-sign),
:deep(.form-item-canvas-img-rec){
  .el-form-item__content{
    border-radius: var(--borderRadiusSize_3);
    // overflow: hidden;
    width: 100%;
    aspect-ratio: 2.2 / 1;
  }
}
:deep(.el-dialog__footer){
  color: red;
  font-size: 12px;
}
:deep(.avatar-uploader){
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }
  .el-upload:hover {
    border-color: var(--el-color-primary);
  }
  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>